import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ConfirmationService, Message, MessageService, TreeNode } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

import { AdministracionService } from '../administracion.service';
import { TareaModel } from 'src/app/modelo/Tarea.model';
import { EliminarData } from 'src/app/modelo/EliminarData';
import { User, UserService } from 'src/app/core';
import { UIService } from 'src/app/core/services/ui.service';
import { FAZILService } from 'src/app/core/services/fazil.service';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-admin-tareas',
    templateUrl: './admin-tareas.component.html',
    styleUrls: ['./admin-tareas.component.scss']
})
export class AdminTareasComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;
    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    tareas: TareaModel[] = [];
    tareasSeleccionados: TareaModel[];
    tareasFiltrados: TareaModel[];
    tarea: TareaModel = new TareaModel();
    grupo: TareaModel = new TareaModel(); //La tarea padre
    tareasTree: TreeNode[] = [];
    tareasTreeNodos: TreeNode[] = [];
    eliminarData: EliminarData;

    //Catálogos

    //Variables auxiliares
    mostrarEditor: boolean = false;
    cols: any[];
    multiSortMeta = [];
    iconos: any[];
    selectedIcon: any;
    opciones = [
        { name: 'No', value: false },
        { name: 'Sí', value: true }
    ];
    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    ui: UIService;

    constructor(
        private router: Router,
        private userService: UserService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private administracionService: AdministracionService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
        private dataService: DataService,
    ) {
        this.ui = uiService;
        this.cargarDataConstructor();
    }

    cargarDataConstructor() {
        this.cargandoDataInit = true;
        this.breadcrumbService.setItems([
            { label: 'Administración de Tareas/Módulos del Sistema', routerLink: ['administracion/tareas'] }
        ]);
        this.cols = [
            { field: 'name', header: 'Nombre', visible: true },
            { field: 'codigo', header: 'Código', visible: false },
            { field: 'descripcion', header: 'Descripción', visible: false },
        ];
        this.multiSortMeta.push({ field: 'nombre', order: 1 });
    }

    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                this.cargarDataInit();
            }
        });
    }

    async cargarDataInit() {
        this.iconos = await this.dataService.getIconosData();
        this.tareas = await this.administracionService.getTareasData();
        this.tareasTree = await this.administracionService.getTareasArbol();
        this.cargandoDataInit = false;
    }

    resetVariables(): void {
        this.ui.limpiarMessages();
        this.mostrarEditor = false;
        this.tareasTreeNodos = [];
        this.grupo = new TareaModel();
        this.tarea = new TareaModel();
        this.tarea.orden = this.tareas.length; //El último de la lista
        this.selectedIcon = null;
    }

    nuevaTarea(): void {
        this.resetVariables();
        this.mostrarEditor = true;
    }

    agregarTarea(node: TreeNode): void {
        this.resetVariables();
        this.grupo = this.tareas.find((item) => item.id == node['id']);
        this.mostrarEditor = true;
    }

    editarTarea(node: TreeNode): void {
        this.resetVariables();
        this.administracionService.getTarea(node['uuid']).subscribe(data => {
            this.tarea = data;
            this.grupo = this.tareas.find((item) => item.id == this.tarea.tareaId) ? this.tareas.find((item) => item.id == this.tarea.tareaId) : new TareaModel();
            if (this.tarea.icon) {
                const etiqueta = this.tarea.icon.substring(12);
                this.selectedIcon = this.iconos.find((item) => item.code == etiqueta);
            }
            this.mostrarEditor = true;
        });
    }

    formPrincipalCompleto() {
        return true;
    }

    guardarTarea(): void {
        this.ui.limpiarMessages();
        if (!this.formPrincipalCompleto()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            //Establecer valores UX
            if (this.grupo && this.grupo.id) {
                this.tarea.tareaId = this.grupo.id;
            } else {
                this.tarea.tareaId = null;
            }
            if (this.selectedIcon && this.selectedIcon.code) {
                this.tarea.icon = "pi pi-fw pi-" + this.selectedIcon.code;
            }
            this.administracionService.guardarTarea(this.tarea).subscribe(
                async (data) => {
                    this.tarea = data;
                    this.tareas = await this.administracionService.getTareasData();
                    this.tareasTree = await this.administracionService.getTareasArbol();
                    this.ui.mostrarMensaje("success", `Actualización de la tarea ${this.tarea.name} se realizó con éxito.`);
                    this.mostrarEditor = false;
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    confirmarBorrarTarea(nd: TreeNode): void {
        this.resetVariables();
        let node = nd['node'];
        if (node['data']['type'] == 'root') {
            this.confirmationService.confirm({
                message: "Esta tarea tiene tareas inferiores que también se borrarán." +
                    "¿Está seguro de eliminar la tarea <strong>" + node['data']['nombre'] + "</strong> y sus inferiores ?. No será posible recuperar la información.",
                accept: () => {
                    this.tareasTreeNodos = this.ui.addNodesToArray(node, 'uuid');
                    this.borrarTareas();
                },
            });
        } else {
            this.confirmationService.confirm({
                message: "¿Está seguro de eliminar la tarea <strong>" + node['data']['nombre'] + "</strong>?. No será posible recuperar la información.",
                accept: () => {
                    this.borrarTarea(node);
                },
            });
        }
    }

    borrarTarea(node: TreeNode): void {
        this.administracionService.borrarTarea(node['data']['uuid']).subscribe(
            async (data) => {
                this.tareas = await this.administracionService.getTareasData();
                this.tareasTree = await this.administracionService.getTareasArbol();
                this.ui.mostrarMensaje("success", `La tarea ${node['data']['nombre']} ha sido eliminada con éxito.`);
            },
            (err) => {
                this.ui.mostrarError(err);
            }
        );
    }

    confirmarBorrarSeleccionados() {
        this.ui.limpiarMessages();
        this.confirmationService.confirm({
            message: "¿Está seguro de eliminar las tareas seleccionadas?. No será posible recuperar la información.",
            accept: () => {
                this.borrarTareas();
            },
        });
    }

    borrarTareas(): void {
        this.eliminarData = new EliminarData();
        if (this.tareasTreeNodos && this.tareasTreeNodos.length) {
            this.eliminarData.uuids = this.tareasTreeNodos.map(function(obj) {
                return obj.data ? obj.data['uuid'] : obj['uuid'];
            });
            this.administracionService.borrarTareas(this.eliminarData).subscribe(
                async (data) => {
                    this.tareas = await this.administracionService.getTareasData();
                    this.tareasTree = await this.administracionService.getTareasArbol();
                    this.tareasTreeNodos = [];
                    this.ui.mostrarMensaje("success", `Las tareas seleccionadas han sido eliminadas con éxito.`);
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        } else {
            this.ui.mostrarMensaje("warn", `No se han seleccionado tareas para su eliminación.`);
        }
    }

    /**
    ** Métodos de formulario
    **/
    filtrarTareas(event) {
        const filtered: any[] = [];
        const query = event.query;
        for (let i = 0; i < this.tareas.length; i++) {
            const tarea = this.tareas[i];
            if (tarea.name.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                filtered.push(tarea);
            }
        }
        this.tareasFiltrados = filtered;
    }

    ///////////////////////////////////////////////////////////////////////////
    //Control de acceso a acciones en pantalla
    // TODO: implementar estos métodos en todas las pantallas
    ///////////////////////////////////////////////////////////////////////////
    puedeEjecutar(accion: string): boolean {
        if (!this.currentUser || !this.currentUser.tareas) { //No tiene esta tarea
            return false;
        }

        const routerLink = this.router.url.replace("/fazil/", "");
        let tarea: TareaModel = new TareaModel;
        tarea = this.currentUser.tareas.find(val => routerLink.startsWith(val.routerLink));

        if (!tarea) { //No tiene esta tarea
            return false;
        }
        if (accion == "lectura") {
            return tarea.puedeLeer;
        } else if (accion == "crear") {
            return tarea.puedeCrear;
        } else if (accion == "escritura") {
            return tarea.puedeEscribir;
        } else if (accion == "borrado") {
            return tarea.puedeBorrar;
        } else if (accion == "aprobar") {
            return tarea.puedeAprobar;
        }
        return false;
    }

    /**
    * Lista de tareas para los roles del usuario autenticado
    */
    getTareasPermisos(routeLink: string): Promise<any> {
        return this.fazilService.getTareasPermisos(routeLink).toPromise();
    }

}